import ClientNavbar from "../layout/ClientNavbar";
import { useState, useContext, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import LocContext from "../context/locContext";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

export default function GstDetails() {
  const { userData } = useContext(LocContext);
  const id = userData?.id || null;
  const [gstData, setGstData] = useState([]);
  const getLoanApplicationData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/gst`,
      );
      if (res.status === 200) {
        setGstData(res.data.data);
      } else {
        setGstData([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getLoanApplicationData();
  }, []);

  // ✅ Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const totalPages = Math.ceil(gstData.length / rowsPerPage);
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentData = gstData.slice(indexOfFirst, indexOfLast);

  const handleNext = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);
  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleRowsChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  // ✅ Modal State
  const [showModal, setShowModal] = useState(false);

  const [data, setData] = useState({
    user_id: id,
    gst_number: "",
    trade_name: "",
    cin_llp: "",
    address: "",
    gst_registration_date: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const trimmedEvent = {
        name: data.trade_name?.trim(),
        cin: data.cin_llp?.trim(),
        gst_number: data.gst_number?.trim(),
      };

      // GST format validation
      const gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

      if (!trimmedEvent.name || !trimmedEvent.cin || !trimmedEvent.gst_number) {
        Swal.fire({
          title: "Please enter all required fields",
          icon: "warning",
        });
      } else if (!gstRegex.test(trimmedEvent.gst_number)) {
        Swal.fire({ title: "Invalid GST Number format", icon: "warning" });
      } else {
        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/gst/store`,
          data,
        );
        if (res.status === 200 && res.data) {
          Swal.fire({
            icon: "success",
            title: "GST Saved Successfully",
            timer: 1500,
          }).then(() => {
            setShowModal(false);
            setData("");
            getLoanApplicationData();
          });
        } else if (res.status === 202) {
          Swal.fire({
            icon: "warning",
            title: res.data.msg,
            timer: 1500,
          });
        } else {
          Swal.fire({ title: "GST Save failed", icon: "error" });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
          <div className="card shadow-sm p-4 mb-4">
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
              <h3 className="text-primary mb-2">GST Details</h3>
              <button
                className="btn btn-primary"
                onClick={() => setShowModal(true)}
              >
                Add GST Information
              </button>
            </div>
            {/* ✅ Header */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>

                <li className="breadcrumb-item active" aria-current="page">
                  Add GST Information
                </li>
              </ol>
            </nav>
      
            </div>

             <div className="card shadow-sm p-4 mb-4">

            {/* ✅ Table */}
            <div className="table-responsive">
              <table className="table table-bordered align-middle text-center">
                <thead style={{ backgroundColor: "#FFE6DC" }}>
                  <tr>
                    <th>Sr.No.</th>
                    <th>GST Number</th>
                    <th>Trade Name</th>
                    <th>Registration Date</th>
                    <th>CIN / LLP</th>
                    <th>Address</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-primary fw-semibold">
                        {indexOfFirst + index + 1}
                      </td>
                      <td>{item.gst_number}</td>
                      <td>{item.trade_name}</td>
                      <td>{item.gst_registration_date.split("T")[0]}</td>
                      <td>{item.cin_llp}</td>
                      <td>{item.address}</td>
                      {/* <td>
                        <span
                          className="badge rounded-pill"
                          style={{
                            backgroundColor: "#ff6600",
                            color: "#fff",
                            fontSize: "0.9rem",
                            padding: "8px 16px",
                          }}
                        >
                          Pending
                        </span>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ✅ Pagination */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3">
              <div>
                <select
                  className="form-select d-inline-block"
                  style={{ width: "80px" }}
                  value={rowsPerPage}
                  onChange={handleRowsChange}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>

              <div className="d-flex align-items-center">
                <button
                  className="btn btn-primary me-2"
                  onClick={handlePrev}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  style={{
                    borderRadius: "50%",
                    width: "36px",
                    height: "36px",
                  }}
                >
                  {currentPage}
                </button>
                <button
                  className="btn btn-primary ms-2"
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </div>

              <div>
                <span>
                  {indexOfFirst + 1}-{rowsPerPage} of {rowsPerPage}
                </span>
              </div>
            </div>

            {/* ✅ Back Button */}
            <div className="mt-4">
              <Link to="/clientloan" className="text-decoration-none text-dark">
                <button className="btn btn-primary px-4">Back</button>
              </Link>
            </div>
          </div>
        </div>

      {/* ✅ Add GST Modal */}
      {showModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4">
              <div className="modal-header border-0">
                <h5 className="modal-title fw-bold">Add GST Information</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label fw-semibold">GST Number *</label>
                  <input
                    type="text"
                    required
                    className={"form-control"}
                    name="gst_number"
                    value={data.gst_number}
                    onChange={handleChange}
                    placeholder="Enter 15-digit GST Number"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    GST Address *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    name="address"
                    value={data.address}
                    onChange={handleChange}
                    placeholder="Enter GST Address"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Date of GST Registration *
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    required
                    name="gst_registration_date"
                    value={data.gst_registration_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Trade Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    name="trade_name"
                    value={data.trade_name}
                    onChange={handleChange}
                    placeholder="Enter Trade Name"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">CIN / LLP *</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    name="cin_llp"
                    value={data.cin_llp}
                    onChange={handleChange}
                    placeholder="Enter CIN / LLP"
                  />
                </div>
              </div>
              <div className="modal-footer border-0 d-flex justify-content-end gap-2">
                <button
                  className="btn btn-primary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
     
    </>
  );
}
